import { render, staticRenderFns } from "./PaineisExternos.vue?vue&type=template&id=15f2a4fe&scoped=true"
import script from "./PaineisExternos.vue?vue&type=script&lang=js"
export * from "./PaineisExternos.vue?vue&type=script&lang=js"
import style0 from "./PaineisExternos.vue?vue&type=style&index=0&id=15f2a4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2a4fe",
  null
  
)

export default component.exports